import { Flex, Stack } from '@chakra-ui/react';
import React from 'react';

import { ProviderCard } from 'Containers/ResultPage/ProviderSelectionContent/ProviderCard';
import { Button } from 'DesignLibrary/atoms';
import { getProviderAddress } from 'Utils/helpers';

import { getProviderDisplayType } from '../../../App/utils';

const ProviderList = ({
  location, // Object representing the location
  providerTypes, // Doctor provider types
  label, // Doctor name
  specialties, // Doctor specialties
  handleProviderDelete, // Handler for deleting provider
  handleProviderEdit, // Handler for editing location of provider
}) => {
  const providerTypeText = getProviderDisplayType(specialties, providerTypes, ' • ');
  const addressText = location?.address_details ? getProviderAddress(location.address_details) : '';

  const subtitle = (
    <Stack spacing={1}>
      <span>{providerTypeText}</span>
      {addressText && <span>{addressText}</span>}
    </Stack>
  );

  return (
    <Flex p={4} justify="space-between" border="var(--border-thick)" borderRadius="var(--border-radius-xs)">
      <ProviderCard title={label} subtitle={subtitle} variant="search" testId="provider-list" />

      <Flex gap={0} flexDir={['column', 'row']}>
        <Button
          onClick={handleProviderEdit}
          buttonType="transparent"
          size="small"
          iconLeft="PencilSimple"
          data-testid="provider-edit-button"
          iconProps={{
            color: '--text-gray',
          }}
        />
        <Button
          onClick={handleProviderDelete}
          buttonType="transparent"
          size="small"
          iconLeft="Trash"
          data-testid="provider-delete-button"
          iconProps={{
            color: '--text-gray',
          }}
        />
      </Flex>
    </Flex>
  );
};

export default ProviderList;
